import { render } from "./field_type.vue?vue&type=template&id=cf128a9c"
import script from "./field_type.vue?vue&type=script&lang=js"
export * from "./field_type.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__